// Soft pastel mesh blobs — pure decoration, sits behind content.
export default function MeshBg({ className = "", variant = "default" }) {
  const sets = {
    default: (
      <>
        <div className="absolute -top-40 -left-32 h-[30rem] w-[30rem] rounded-full bg-indigo-300/40 blur-[110px]" />
        <div className="absolute top-10 right-0 h-[26rem] w-[26rem] rounded-full bg-pink-200/50 blur-[110px]" />
        <div className="absolute bottom-0 left-1/3 h-[24rem] w-[24rem] rounded-full bg-emerald-200/40 blur-[110px]" />
        <div className="absolute -bottom-20 -right-10 h-[22rem] w-[22rem] rounded-full bg-amber-100/70 blur-[110px]" />
      </>
    ),
    cool: (
      <>
        <div className="absolute -top-24 left-1/4 h-[24rem] w-[24rem] rounded-full bg-indigo-200/50 blur-[110px]" />
        <div className="absolute bottom-0 right-10 h-[22rem] w-[22rem] rounded-full bg-sky-200/50 blur-[110px]" />
      </>
    ),
    warm: (
      <>
        <div className="absolute -top-24 right-1/4 h-[24rem] w-[24rem] rounded-full bg-amber-100/70 blur-[110px]" />
        <div className="absolute bottom-0 left-10 h-[22rem] w-[22rem] rounded-full bg-emerald-200/40 blur-[110px]" />
      </>
    ),
  };
  return (
    <div aria-hidden className={"pointer-events-none absolute inset-0 -z-10 overflow-hidden " + className}>
      {sets[variant] || sets.default}
    </div>
  );
}
